import React, { Fragment } from 'react';
import Row from 'reactstrap/lib/Row';
import Col from 'reactstrap/lib/Col';
import { Form, Formik } from 'formik';
import Loading from 'components/Loading';
import classNames from 'classnames';
import ButtonSearchAndReset from 'components/Buttons/ButtonSearchAndReset';

const propTypes = {};

const SearchAndFilters = ({
  initialValues,
  isSearching = false,
  onSubmitSearch = () => {},
  onResetSearch,
  renderFilter,
  classNameRowSearch = '',
  classNameContainer = '',
  classNameButtonContainer = '',
  classNameFields = '',
  styleFiltersContainer = {},
  styleFieldsContainer = {},
  disableSearchResetDefault = false,

  isNotRow = false,
  enableReinitialize = true,
  validationSchema,
}) => {
  //! State

  //! Function

  //! Render
  const ComponentRow = isNotRow ? Fragment : Row;
  const ComponentCol = isNotRow ? Fragment : Col;

  const propsComponentCol = isNotRow
    ? {}
    : {
        xs: '12',
        md: '12',
      };

  return (
    <ComponentRow>
      <Formik
        enableReinitialize={enableReinitialize}
        validateOnBlur={false}
        validateOnChange={false}
        validationSchema={validationSchema}
        initialValues={initialValues}
        onSubmit={onSubmitSearch}
      >
        {(propsFormik) => (
          <ComponentCol {...propsComponentCol}>
            <Form
              className={`search-filters gap-8px ${classNameContainer}`}
              style={styleFiltersContainer}
            >
              <div
                className={classNames(
                  'search-filters__fields',
                  disableSearchResetDefault && 'w-100',
                  classNameFields
                )}
                style={styleFieldsContainer}
              >
                {renderFilter({ propsFormik, onResetSearch })}
              </div>

              {!disableSearchResetDefault && (
                <div
                  className={classNames(
                    'search-filters__button tw-w-full md:tw-w-auto',
                    classNameButtonContainer
                  )}
                >
                  <ButtonSearchAndReset
                    isSearching={isSearching}
                    onClickReset={onResetSearch(propsFormik)}
                  />
                </div>
              )}
            </Form>
          </ComponentCol>
        )}
      </Formik>
    </ComponentRow>
  );
};

SearchAndFilters.propTypes = propTypes;
export default SearchAndFilters;
